import { ReactNode } from "react";

interface TextProps {
  type: "h1" | "title" | "subtitle" | "main";
  children: ReactNode;
  className?: string;
}

function Text({ type, children, className }: TextProps) {
  switch (type) {
    case "h1":
      return (
        <h1 className={`sm:text-h1 text-h1-mobile ${className}`}>{children}</h1>
      );
    case "title":
      return (
        <h2 className={`sm:text-title text-title-mobile font-medium ${className}`}>
          {children}
        </h2>
      );
    case "subtitle":
      return (
        <h3
          className={`sm:text-subtitle text-subtitle-mobile leading-[100%] font-medium ${className}`}
        >
          {children}
        </h3>
      );
    case "main":
      return (
        <p className={`sm:text-main text-main-mobile tracking-[0.2px] leading-[120%] ${className}`}>
          {children}
        </p>
      );
  }
}

export { Text };
